const INPUT_DELAY = 600;
export {
  INPUT_DELAY
};
